import React, { useEffect } from "react";
import useInView from "./utils/useInView";
import { useFetchCategory, useCategory } from "./stores/publicStore";
import { icons } from "./utils/icons";
import { useNavigate } from "react-router-dom";

const Buttons = () => {
    const [ref, inView] = useInView();
    const navigate = useNavigate();
    const categories = useCategory();
    const fetchCategories = useFetchCategory();

    useEffect(() => {
        void fetchCategories();
    }, [fetchCategories]);

    const handleClick = (cat) => {
        navigate(`/detail/result`, { state: { category: cat } });
    };

    return (
        <div
            ref={ref}
            className={`opacity-0 scale-90 transition-all duration-500 ${inView ? "animate-fadeIn" : ""}`}
        >
            <div className="container text-white flex flex-wrap gap-x-2 py-4 md:gap-x-6 items-start md:items-end justify-center h-fit gap-y-5 md:h-[25vh]">
                {categories.map((button, index) => {
                    const Icon = icons[button.realty_type] || icons.default;
                    return (
                        <button
                            key={button.id || index}
                            className="flex items-center text-sm bg-[#6FB3FA] py-0.5 px-1.5 md:p-2 rounded-2xl gap-2"
                            onClick={() => handleClick(button)}
                        >
                            {Icon}
                            {button.name}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default Buttons;
